import emotionStyled from '@emotion/styled'
import React from 'react'
import paalai from '../../../assets/paalai.png';
// import nenoai from '../../../assets/neonai.png';
// import xtrack from '../../../assets/xtrack.png';
// import resai from '../../../assets/resai.png';
// import otsea from '../../../assets/otsea.png';
// import toadswap from '../../../assets/toadswap.png';

import zxhi from '../../../assets/zxhi.png'
import tatsu from '../../../assets/tatsu.png'
import spai from '../../../assets/spai.png'

const logos = [
  paalai,spai,zxhi
,tatsu
  //  nenoai, xtrack, resai, otsea, toadswap
];
const MarkeeContainer = emotionStyled.div`
    width: 100%;
    overflow-x: hidden;
    white-space: nowrap;
    
    .marquee {
        display: inline-block;
        white-space: nowrap;
        text-transform: uppercase;
        -webkit-text-stroke: 2px black;
        animation: scrolling 35s linear infinite;
    }
    
    &:hover .marquee {
        animation-play-state: paused;
    }
    
    .marquee span {
        padding-right: 30px;
        img{
            height: 40px;
            width: auto;
            margin: 20px 0 15px;
            
            @media(max-width: 1600px){
                height: 50px;
                margin: 20px 0 15px;
            }
        }
    }

    @keyframes scrolling {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
    }
`

export const Markee = () => {
  return (
    <MarkeeContainer>
        <div className="marquee">
        {[...Array(20)].map((_, i) => (
          logos.map((logo, index) => (
            <span key={`${i}-${index}`}>
              <img src={logo} style={{width:'100%', maxWidth:'250px', height:'auto'}} alt="logo"  draggable='false'/>
            </span>
          ))
        ))}
      </div>
    </MarkeeContainer>
  )
}